import { Directive ,ElementRef,Input} from '@angular/core';
import {NgControl} from '@angular/forms'

@Directive({
  selector: '[InputFormat]',
  host: {
    // '(keypress)': '_onKeypress($event)',
    // '(keydown)': '_onKeyup($event)',
    '(input)': 'Show($event)',
    
  }
})

export class InputFormatDirective {
  @Input("ngModel") type :string = ''  
  _input : ElementRef;
  _labelDom:any;
  _span:any;

  formatType ={
      onlyEn : /[^a-zA-Z]/g,
      noCH: /[^\u4E00-\u9FA5]/g,
      email:/[^\w=@#.]|_/ig
  }
  
  constructor(el: ElementRef) {
      this._input = el;
      this._labelDom = el.nativeElement.previousElementSibling ;

       
       let span = document.createElement("span");
       span.style.color="red";
       span.classList.add("label");
       span.classList.add("text-danger");
       span.innerText="   不可有中文";
       span.style.display="none";
       this._labelDom.appendChild(span);
       this._span=span
      

  }


  
  Show(e) {
    if( this.Judge (e.target.value)){
      this._input.nativeElement.classList.remove("status-basic") 
      this._input.nativeElement.classList.add("status-danger")
      this._span.style.display="inline";
    }     
    else{
      this._input.nativeElement.classList.remove("status-danger") 
      this._input.nativeElement.classList.add("status-basic")
      this._span.style.display="none";
    }     
  }

 

  Judge (e){
    var regu = /[^\w=@#.]|_/ig ;
    return regu.test(e);    
  }




  
}

